import useInputValueLangaugeDetector from "customHooks/useInputValueLangaugeDetector";
import useTranslation from "next-translate/useTranslation";
import { Controller } from "react-hook-form";
import LengthIndicator from "../LengthIndicator";

type Props = {
  control: any;
  name: string;
  watch: any;
  placeholder?: string;
  noMB?: boolean;
  textLength?: number;
};

function CommentController({
  control,
  name,
  placeholder,
  watch,
  noMB,
  textLength,
}: Props) {
  const { t } = useTranslation("common");
  const { dir, onInputFocus, onInputBlur } = useInputValueLangaugeDetector(
    watch(name)
  );
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { name, onChange, ref, value },
        fieldState: { error },
      }) => {
        return (
          <>
            <textarea
              autoFocus
              onChange={onChange}
              value={value}
              dir={dir}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              name={name}
              ref={ref}
              id="comment"
              className="form-control lh17 scrollbar-none"
              rows={4}
              placeholder={
                placeholder ? placeholder : t(`write_your_comment_here`)
              }
            ></textarea>
            <div
              className={`v-centered justify-content-between mt-1 ${
                noMB ? "" : "mb-3"
              }`}
            >
              <div
                className="invalid-feedback m-0"
                style={{ width: "fit-content" }}
              >
                {error?.message && error?.message}
              </div>
              <LengthIndicator
                value={value}
                textLength={textLength || 250}
                textMinLength={10}
              />
            </div>
          </>
        );
      }}
    />
  );
}

export default CommentController;
